var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    fill: "#FFF",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 10.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 15.75v3.75a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-15a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v11.25ZM19.5 3h-15A1.5 1.5 0 0 0 3 4.5v9.44l3.97-3.97a.75.75 0 0 1 1.06 0L12 13.94l1.72-1.72a.75.75 0 0 1 1.06 0L21 18.44V4.5A1.5 1.5 0 0 0 19.5 3Zm1.258 17.318-6.508-6.507-1.72 1.72a.75.75 0 0 1-1.06 0L7.5 11.56 3 16.06V19.5A1.5 1.5 0 0 0 4.5 21h15c.527 0 .99-.271 1.258-.682Z"
  })));
};
export default SvgImage;